<script>
  import * as restfulService from '../../../services/restfulService'

  import helpers from '@mixins/helper'

  import {mapActions} from 'vuex'

  import {required, email} from 'vuelidate/lib/validators'

  import NavigationButtons from './NavigationButtons'

  import bus from '@utils/bus'

  export default {
    mixins: [helpers],
    components: {NavigationButtons},
    name: 'dados-pessoais',
    props: {
      dados: {
        required: true,
        type: Object,
        default: () => ({})
      },
      etapaAtiva: {
        type: Number,
        default: 0
      },
      desabilita: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        buscandoCidades: false,
        buscarCidade: '',
        mostrarDatepickerDtNascimento: false,
        dependencias: {
          cidades: []
        }
      }
    },
    computed: {
      dadosMatricula: {
        get () {
          return this.dados
        },
        set (value) {
          this.$emit('update:dados', value)
        }
      },
      dt_nascimento_formatada () {
        return this.dadosMatricula.pessoa_fisica.dt_nascimento ? this.dateFormat(this.dadosMatricula.pessoa_fisica.dt_nascimento, 'br') : ''
      }
    },
    validations: {
      dadosMatricula: {
        pessoa: {
          nome: {required},
          email: {required, email},
          cep: {required},
          rua: {required},
          numero: {required},
          bairro: {required},
          ref_cidade: {required}
        },
        pessoa_fisica: {
          dt_nascimento: {required},
          fone_celular: {required},
          cpf: {required},
          rg_numero: {required}
        }
      }
    },
    watch: {
      buscarCidade (query) {
        if (!this.dadosMatricula.pessoa.ref_cidade) {
          this.buscarCidades(query)
        }
      }
    },
    async mounted () {
      await this.buscarDadosPessoais()
    },
    methods: {
      ...mapActions(['showNotification']),
      buscarDadosPessoais () {
        restfulService.get('pessoa', 'meus-dados')
          .then(response => {
            this.dadosMatricula.pessoa_fisica = {...response.pessoa_fisica}
            this.dadosMatricula.endereco_cobranca = {...response.endereco_cobranca}
            this.dadosMatricula.pessoa = {...response}
            this.dadosMatricula.pessoa_fisica.dt_nascimento_formatada = this.dateFormat(this.dadosMatricula.pessoa_fisica.dt_nascimento, 'br')
            if (response.cidade) {
              this.dependencias.cidades.push(response.cidade)
            }
          })
          .catch(e => {
            console.log(e)
          })
      },
      buscarCidades (query) {
        this.dadosMatricula.pessoa.ref_cidade = null
        return new Promise((resolve, reject) => {
          if (query !== null && query !== '') {
            this.dependencias.cidades.splice(0)
            this.buscandoCidades = true
            let data = {nome: {ilike: '%' + query + '%'}}
            restfulService.search('cidade', null, data, null, ['estado'])
              .then((response) => {
                this.dependencias.cidades = [...response.data]
                this.buscandoCidades = false
                resolve()
              })
              .catch(e => {
                console.log(e)
                this.buscandoCidades = false
                reject()
              })
          } else {
            resolve()
          }
        })
      },
      salvarDados () {
        let data = {
          pessoa: {...this.dadosMatricula.pessoa},
          pessoa_fisica: {...this.dadosMatricula.pessoa_fisica}
        }
        data.pessoa_fisica.fone_celular = this.onlyNumbers(data.pessoa_fisica.fone_celular)
        data.pessoa_fisica.cpf = this.onlyNumbers(data.pessoa_fisica.cpf)
        delete data.pessoa.cidade
        delete data.pessoa.pessoa_fisica
        delete data.pessoa.usuario
        delete data.pessoa.necessidades_especiais
        delete data.pessoa.endereco_cobranca
        delete data.pessoa_fisica.dt_nascimento_formatada
        delete data.pessoa_fisica.formacao_academica
        delete data.pessoa_fisica.experiencias_profissionais
        delete data.pessoa_fisica.naturalidade
        bus.$emit('show-loader')
        restfulService.post('pessoa', null, null, data)
          .then(() => {
            this.showNotification({
              message: 'Seus dados pessoais foram salvos'
            })
            this.desabilita.aba1 = true
            this.desabilita.aba2 = false
            this.$emit('update:etapaAtiva', (this.etapaAtiva + 1))
            this.$emit('update:desabilita', this.desabilita)
          })
          .catch(e => {
            console.log(e)
          })
        bus.$emit('hide-loader')
      }
    }
  }
</script>

<template>
    <v-container fluid grid-list-md>
        <v-layout row wrap>
            <v-flex sm4 xs12>
                <v-text-field v-model="dadosMatricula.pessoa.nome"
                              label="Nome"
                              :error-messages="validationMessageField($v.dadosMatricula.pessoa.nome)"
                              @input="$v.dadosMatricula.pessoa.nome.$touch()"
                              @blur="$v.dadosMatricula.pessoa.nome.$touch()"
                              required/>
            </v-flex>
            <v-flex sm4 xs12>
                <v-text-field v-model="dadosMatricula.pessoa_fisica.cpf"
                              label="CPF"
                              mask="###.###.###-##"
                              :error-messages="validationMessageField($v.dadosMatricula.pessoa_fisica.cpf)"
                              @input="$v.dadosMatricula.pessoa_fisica.cpf.$touch()"
                              @blur="$v.dadosMatricula.pessoa_fisica.cpf.$touch()"
                              required/>
            </v-flex>
            <v-flex sm4 xs12>
                <v-text-field v-model="dadosMatricula.pessoa_fisica.rg_numero"
                              label="RG"
                              :error-messages="validationMessageField($v.dadosMatricula.pessoa_fisica.rg_numero)"
                              @input="$v.dadosMatricula.pessoa_fisica.rg_numero.$touch()"
                              @blur="$v.dadosMatricula.pessoa_fisica.rg_numero.$touch()"
                              required/>
            </v-flex>
            <v-flex sm3 xs12>
                <v-menu ref="datepickerDtNascimento"
                        :close-on-content-click="false"
                        v-model="mostrarDatepickerDtNascimento"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px">
                    <v-text-field slot="activator"
                                  v-model="dt_nascimento_formatada"
                                  @blur="$v.dadosMatricula.pessoa_fisica.dt_nascimento.$touch()"
                                  v-mask="'##/##/####'"
                                  label="Data de Nascimento"
                                  prepend-icon="event"/>
                    <v-date-picker v-model="dadosMatricula.pessoa_fisica.dt_nascimento"
                                   @input="$v.dadosMatricula.pessoa_fisica.dt_nascimento.$touch()"
                                   @blur="$v.dadosMatricula.pessoa_fisica.dt_nascimento.$touch()"
                                   :error-messages="validationMessageField($v.dadosMatricula.pessoa_fisica.dt_nascimento)"
                                   :no-title="true"
                                   locale="pt-br"/>
                </v-menu>
            </v-flex>
            <v-flex sm5 xs12>
                <v-text-field v-model="dadosMatricula.pessoa.email"
                              label="E-mail Principal"
                              :error-messages="validationMessageField($v.dadosMatricula.pessoa.email, ['required', 'email'])"
                              @input="$v.dadosMatricula.pessoa.email.$touch()"
                              @blur="$v.dadosMatricula.pessoa.email.$touch()"
                              required/>
            </v-flex>
            <v-flex sm4 xs12>
                <v-text-field v-model="dadosMatricula.pessoa_fisica.fone_celular"
                              :error-messages="validationMessageField($v.dadosMatricula.pessoa_fisica.fone_celular)"
                              @input="$v.dadosMatricula.pessoa_fisica.fone_celular.$touch()"
                              @blur="$v.dadosMatricula.pessoa_fisica.fone_celular.$touch()"
                              mask="(##) #####-####"
                              label="Telefone Celular"/>
            </v-flex>
            <v-flex sm3 xs12>
                <v-text-field v-model="dadosMatricula.pessoa.cep"
                              :error-messages="validationMessageField($v.dadosMatricula.pessoa.cep)"
                              @input="$v.dadosMatricula.pessoa.cep.$touch()"
                              @blur="$v.dadosMatricula.pessoa.cep.$touch()"
                              mask="#####-###"
                              label="CEP"
                              required/>
            </v-flex>
            <v-flex sm5 xs12>
                <v-text-field v-model="dadosMatricula.pessoa.rua"
                              :error-messages="validationMessageField($v.dadosMatricula.pessoa.rua)"
                              @input="$v.dadosMatricula.pessoa.rua.$touch()"
                              @blur="$v.dadosMatricula.pessoa.rua.$touch()"
                              label="Rua"
                              required/>
            </v-flex>
            <v-flex sm4 xs12>
                <v-text-field v-model="dadosMatricula.pessoa.numero"
                              :error-messages="validationMessageField($v.dadosMatricula.pessoa.numero)"
                              @input="$v.dadosMatricula.pessoa.numero.$touch()"
                              @blur="$v.dadosMatricula.pessoa.numero.$touch()"
                              label="Número"
                              required/>
            </v-flex>
            <v-flex sm4 xs12>
                <v-text-field v-model="dadosMatricula.pessoa.bairro"
                              :error-messages="validationMessageField($v.dadosMatricula.pessoa.bairro)"
                              @input="$v.dadosMatricula.pessoa.bairro.$touch()"
                              @blur="$v.dadosMatricula.pessoa.bairro.$touch()"
                              label="Bairro"
                              required/>
            </v-flex>
            <v-flex sm4 xs12>
                <v-text-field v-model="dadosMatricula.pessoa.complemento"
                              label="Complemento"/>
            </v-flex>
            <v-flex sm4 xs12>
                <v-autocomplete v-model="dadosMatricula.pessoa.ref_cidade"
                                :error-messages="validationMessageField($v.dadosMatricula.pessoa.ref_cidade)"
                                @input="$v.dadosMatricula.pessoa.ref_cidade.$touch()"
                                @blur="$v.dadosMatricula.pessoa.ref_cidade.$touch()"
                                :items="dependencias.cidades"
                                :loading="buscandoCidades"
                                :search-input.sync="buscarCidade"
                                browser-autocomplete="matriculaonlineautocompletecidade"
                                item-value="id"
                                label="Cidade"
                                placeholder="Digite o nome da cidade"
                                no-data-text="Nenhuma registro encontrado"
                                hide-no-data
                                hide-selected
                                no-filter
                                clearable>
                    <template slot="item" slot-scope="data">
                        {{data.item.nome}} / {{data.item.ref_estado}}
                    </template>
                    <template slot="selection" slot-scope="data">
                        {{data.item.nome}} / {{data.item.ref_estado}}
                    </template>
                </v-autocomplete>
            </v-flex>
        </v-layout>
        <div class="flex-header">
          <navigation-buttons
            :show-previous="false"
            :show-next="true"
            :next-click="salvarDados"
            :disable-next="$v.dadosMatricula.$invalid"
          >
          </navigation-buttons>
        </div>
    </v-container>
</template>



// WEBPACK FOOTER //
// DadosPessoais.vue?dc284668